module.exports = __webpack_public_path__ + "static/media/cq_minus_b.57644bfa.svg";